export default __webpack_public_path__ + "../staticImages/advent-bottle-bg.jpg";